import React from 'react';
import { defaultArrowProps } from './icon_helpers';

const UpArrow = ({ width, strokeWidth, color, className }) => (
  <svg
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      strokeWidth={strokeWidth}
      fill={color}
      stroke={color}
      d="M10.168 7.864l-6.485 6.13c-.3.285-.775.27-1.06-.03-.285-.3-.27-.775.03-1.06L10.168 5.8l7.515 7.104c.3.285.315.76.03 1.06-.285.3-.76.315-1.06.03l-6.485-6.13z"
    />
  </svg>
);

UpArrow.defaultProps = defaultArrowProps;

export default UpArrow;
